import { DataTablePageSizeEnum } from '@/enums';
import { useQueryParams } from '@/hooks';

type TName = 'sortType' | 'sortBy' | 'limit' | 'page' | 'gender' | 'createdAtFrom' | 'createdAtTo' | 'name' | 'email';

const useUrlParams = () => {

  const { values: [sortType, sortBy, limit, page, gender, createdAtFrom, createdAtTo, name, email], setValue } = useQueryParams(
    ['sortType', 'sortBy', 'limit', 'page', 'gender', 'createdAtFrom', 'createdAtTo', 'name', 'email'],
    { limit: DataTablePageSizeEnum._50, page: 1 }
  );

  return ({
    setValue: (name: TName, value: any) => setValue(name, value),
    limit: limit as DataTablePageSizeEnum,
    createdAtFrom,
    createdAtTo,
    sortType,
    gender,
    sortBy,
    email,
    page,
    name
  });

};

export default useUrlParams;
